<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" label="道闸类型:" :label-width="100">
				<Select placeholder="道闸类型" style="width: 200px;" v-model="formInline.Type">
					<Option :value="0">全部</Option>
					<Option :value="1">智慧云停车</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName" label="名称:" :label-width="100">
				<Input type="text" v-model="formInline.Name" placeholder="名称" />
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<div style="float: right;">
				<Button type="primary" @click="showModal('add')" v-if="hasWidgets('add')">添加</Button>
			</div>
		</Form>
		<Table :row-class-name="rowClassName" :columns="tableColumns" :data="tabelDatas" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getStationParkingUrl" @listData='getTableData'></MyPage>
		<Modal :mask-closable="false" v-model="modalView" :title="modal.Title" width="80%">
			<!--安装和修改-->
			<Form label-position="right" :rules="ruleInline"
				v-if="modal.type=='add'||modal.type=='update'||modal.type=='view'" ref="StationParkingForm"
				:model="StationParkingForm" :label-width="150">
				<Row>
					<Col :span="7">
					<FormItem v-show='false' label="Id标识" prop="Id">
						<Input :disabled="ifView" v-model="StationParkingForm.Id" placeholder="Id标识"></Input>
					</FormItem>
					</Col>
					<!-- <Col :span="7">
					<FormItem v-show='false' label="名称" prop="Name">
						<Input :disabled="ifView" v-model="StationParkingForm.Name"
							placeholder="名称"></Input>
					</FormItem>
					</Col> -->
				</Row>
				<Row style="margin-bottom: 10px;">
					<Col :span="7">
					<FormItem label="道闸类型" prop="Type">
						<Select :disabled="ifView" placeholder="道闸类型" v-model="StationParkingForm.Type">
							<Option :value="1">智慧云停车</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="名称" prop="Name">
						<Input :disabled="ifView" v-model="StationParkingForm.Name" placeholder="名称"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="是否启用" prop="Enable">
						<i-switch :disabled="ifView" :true-value='1' :false-value='0' v-model="StationParkingForm.Enable"
							size="large">
							<span slot="open">启用</span>
							<span slot="close">停用</span>
						</i-switch>
					</FormItem>
					</Col>
				</Row>
				<Row style="margin-bottom: 10px;">
					<Col :span="7">
					<FormItem label="项目编码/Token" prop="ProjectCode">
						<Input :disabled="ifView" v-model="StationParkingForm.ProjectCode" placeholder="项目编码/Token"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="车场编码" prop="ParkId">
						<Input :disabled="ifView" v-model="StationParkingForm.ParkId" placeholder="车场编码"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="商户ID" prop="ShopId">
						<Input :disabled="ifView" v-model="StationParkingForm.ShopId" placeholder="商户ID"></Input>
					</FormItem>
					</Col>
					<!-- <Col :span="7">
					<FormItem label="是否推送" prop="EnablePush">
						<i-switch :disabled="ifView" :true-value='1' :false-value='0'
							v-model="StationParkingForm.EnablePush" size="large">
							<span slot="open">推送</span>
							<span slot="close">推送</span>
						</i-switch>
					</FormItem>
					</Col> -->
				</Row>
				<!-- <Divider orientation="left">本地运营商</Divider> -->
				<Row style="margin-bottom: 10px;">
					<!-- <Col :span="7">
					<FormItem label="推送URL" prop="PushUrl">
						<Select placeholder="运营商名称" v-model="StationParkingForm.PushUrl">
							<Option v-bind:key="item.Id" v-for="(item) in typeList" :value="item.Id">{{item.Name}}
							</Option>
						</Select>
					</FormItem>
					</Col> -->
				</Row>
				<Row style="margin-bottom: 10px;">
					<Col :span="7">
					<FormItem label="AppId" prop="AppId">
						<Input :disabled="ifView" v-model="StationParkingForm.AppId" placeholder="AppId"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="AppSecret" prop="AppSecret">
						<Input :disabled="ifView" v-model="StationParkingForm.AppSecret" placeholder="AppSecret"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row style="margin-bottom: 10px;">
					<Col :span="7">
					<FormItem label="推送URL" prop="PushUrl">
						<Input :disabled="ifView" v-model="StationParkingForm.PushUrl" placeholder="推送URL"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="推送时机" prop="TimingForPush">
						<Select :disabled="ifView" placeholder="推送时机" v-model="StationParkingForm.TimingForPush">
							<Option :value="1">订单结算后</Option>
							<Option :value="2">订单创建时</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<!-- <Divider orientation="left">互联互通运营商</Divider> -->
				<Row>
					<Col :span="7">
					<FormItem label="优惠类型" prop="CouponType">
						<Select :disabled="ifView" placeholder="优惠类型" v-model="StationParkingForm.CouponType">
							<!-- <Option :value="0">金额</Option> -->
							<Option :value="1">时长</Option>
							<!-- <Option :value="2">全免</Option> -->
						</Select>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="优惠额度" prop="CouponValue">
						<Input :disabled="ifView" v-model="StationParkingForm.CouponValue"
							placeholder="优惠额度（单位：元或者 分钟）0-按实际值; 其他-按固定值"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col :span="7">
					<FormItem label="优惠额度起始值" prop="CouponValueLower">
						<Input :disabled="ifView" v-model="StationParkingForm.CouponValueLower"
							placeholder="优惠额度起始值"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="优惠额度最高值" prop="CouponValueUpper">
						<Input :disabled="ifView" v-model="StationParkingForm.CouponValueUpper"
							placeholder="优惠额度最高值"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col :span="7">
					<FormItem label="备注" prop="Remark">
						<Input :disabled="ifView" v-model="StationParkingForm.Remark" placeholder="备注"></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div v-if="modal.type=='add'" slot="footer">
				<Button v-if="modal.type!='install'" type="warning" size="large" @click="modalReset">重置</Button>
				<Button type="success" size="large" @click="modalOk('add')">新增</Button>
			</div>
			<div v-if="modal.type=='update'" slot="footer">
				<Button type="success" size="large" @click="modalOk('up')">确认修改</Button>
			</div>
			<div v-if="modal.type=='view'" slot="footer">
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		data() {
			return {
				getStationParkingUrl: webapi.base_api_url + '/Operations/GetStationParking',
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				tableHeight: "650",
				modal: {
					Title: "信息添加",
					type: "addDevice"
				},
				BreadcrumbList: ['运营管理', '>>', '道闸管理'],
				formInline: {
					Type: 0,
					Name: '',
				},
				//table标题数据
				tableColumns: [{
						title: '名称',
						key: 'Name',
						minWidth: 120,
					}, {
						title: '类型',
						key: 'ParkingTypeDesc',
						minWidth: 120,
					},
					{
						title: '项目编码',
						key: 'ProjectCode',
						minWidth: 100,
					},
					{
						title: '车场编码',
						key: 'ParkId',
						minWidth: 100,
					},
					{
						title: '推送URL',
						key: 'PushUrl',
						minWidth: 180,
					},
					{
						title: '推送时机',
						key: 'TimingForPush',
						minWidth: 120,
					},
					{
						title: 'AppId',
						key: 'AppId',
						minWidth: 120,
					},
					{
						title: 'AppSecret',
						key: 'AppSecret',
						minWidth: 160,
					},
					{
						title: '商户ID',
						key: 'ShopId',
						minWidth: 100,
					},
					{
						title: '优惠类型',
						key: 'CouponTypeDesc',
						minWidth: 100,
					},
					{
						title: '优惠额度',
						key: 'CouponValue',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								params.row.CouponValue + (params.row.CouponType == 0 ? '元' : params.row.CouponType == 1 ? "分钟" :
									"")
							);
						}
					},
					{
						title: '优惠起始值',
						key: 'CouponValueLower',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								params.row.CouponValueLower + (params.row.CouponType == 0 ? '元' : params.row.CouponType == 1 ?
									"分钟" : "")
							);
						}
					},
					{
						title: '优惠最高值',
						key: 'CouponValueUpper',
						minWidth: 100,
						render: (h, params) => {
							return h('div',
								params.row.CouponValueUpper + (params.row.CouponType == 0 ? '元' : params.row.CouponType == 1 ?
									"分钟" : "")
							);
						}
					},
					{
						title: '是否启用',
						key: 'EnableDesc',
						minWidth: 100,
					},
					{
						title: '备注',
						key: 'Remark',
						minWidth: 100,
					},
					{
						title: '操作',
						key: 'action',
						width: 200,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px',
									},
									on: {
										click: () => {
											this.showModal("update", params.row)
										}
									}
								}, '修改') : h(),
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										//为了不误操作，确定取消相反
										click: () => {
											this.showModal("view", params.row)
										}
										// this.show("deleteStation", params.row.Id)
									}
								}, '查看') : h(),
							]);
						}
					}
				],
				tabelDatas: [],
				// timer: ''
				StationParkingForm: {},
				ruleInline: {
					Type: [{
						required: true,
						message: '请选择道闸类型',
						trigger: 'charge',
						type: 'number',
					}],
					Name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}],
					ParkId: [{
						required: true,
						message: '请输入车场编码',
						trigger: 'blur',
					}],
					PushUrl: [{
						required: true,
						message: '请输入推送URL',
						trigger: 'blur'
					}],
					TimingForPush: [{
						required: true,
						message: '请选择推送时机',
						trigger: 'charge',
						type: 'number',
					}],
					CouponType: [{
						required: true,
						message: '请选择优惠类型',
						trigger: 'charge',
						type: 'number',
					}],
				},
				modalView: false,
				ifView: false,
				ifModify: false,
			}
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		updated() {},
		activated() {
			// this.timer = setInterval(this.handleSubmit, 30000);
		},
		deactivated() {
			// if (this.timer) {
			// 	clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			// }
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			const _this = this
			_this.handleSubmit();
		},
		beforeDestroy() {},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = _this.formInline;
				return param
			},
			//直接选属性
			...mapState({
				// StationList: 'Stations'
			})
		},
		methods: {
			rowClassName: function(row, index) {
				if (index % 2 == 0) {
					return 'demo-table-info-row';
				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//操作
			showModal: function(type, row) {
				switch (type) {
					case "add":
						this.modal.type = "add";
						this.modal.Title = "道闸信息添加";
						this.ifModify = false
						this.ifView = false
						this.modalReset();
						break;
					case "update":
						this.modal.type = "update";
						this.modal.Title = "道闸信息修改";
						this.ifModify = true
						this.modalFill(row);
						this.ifView = false
						break;
					case "view":
						this.modal.type = "view";
						this.modal.Title = "道闸信息查看";
						this.modalFill(row);
						this.ifModify = false,
						this.ifView = true
						break;
				}
				this.modalView = true;

			},
			getTableData: function(data) {
				console.log(data)
				this.tabelDatas = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
			modalReset: function() {
				this.uploadList = []
				this.$nextTick(() => {
					this.$refs.StationParkingForm.resetFields();
					this.$refs.upload.clearFiles();
					this.defaultList = this.$refs.upload.fileList
				})
			},
			modalFill: function(row) {
				console.log(row);
				const _this = this;
				_this.StationParkingForm = Object.assign({}, row)
				// for (let i = 0; i < _this.tabelDatas.length; i++) {
				// 	if (_this.tabelDatas[i].Id == Id) {
				// 		_this.StationParkingForm = Object.assign({}, _this.tabelDatas[i])
				// 		break;
				// 	}
				// }
			},
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case "add":
						_this.StationParkingForm.Id = 0
						break;
				}
				const param = _this.StationParkingForm
				this.$refs.StationParkingForm.validate((valid) => {
					console.log("道闸" + type + "----" + valid)
					if (valid) {
						let path = '';
						let operate = '';
						if (type == 'add') {
							path = '/Operations/AddStationParking';
							operate = '添加';
						} else if (type == 'up') {
							path = '/Operations/ModifyStationParking';
							operate = '修改';
						}
						if (!path) return;
						_this.$axios.post(webapi.base_api_url + path,
							param
						).then(res => {
							console.log(res)
							if (res.data.Code == 0) {
								this.$Message.success("道闸" + operate + "成功");
								this.$refs.sonPage.getList();
								this.modalView = false;
							} else {
								this.$Message.error("道闸" + operate + "失败");
							}
						})
					}
				})
			},
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>